import { BaseClient } from '../client';
import { UserMock } from './user.mocks';
import { TUser } from './user.types';

interface getUserByIdProps {
	id: string;
}

export const getUserById = async ({ id }: getUserByIdProps) => {
	if (process.env.NODE_ENV === 'development') {
		const groupsId = sessionStorage.getItem('groupsid') || '2';

		const defineGroupName = () => {
			switch (groupsId) {
				case '1':
					return 'Administrador';
				case '2':
					return 'Concessionária';
				default:
					return 'Lojista';
			}
		};

		const response: TUser = {
			...UserMock,
			grupoAcesso: { ...UserMock.grupoAcesso, id: +groupsId, nome: defineGroupName() },
		};

		return response;
	}

	try {
		const response = await BaseClient.get<TUser[]>(`/Usuarios/${id}`).then(
			(response) => response.data
		);

		return response.at(0);
	} catch (error) {
		console.error(error);
	}
};
